import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import IconStyles from './iconStyles';

export const ICON_TYPE = {
  ADD: {
    svgViewBox: '0 0 8 8',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
    <line x1="4" x2="4" y1=".444" y2="7.556"/>
    <line x1=".444" x2="7.556" y1="4" y2="4"/>
  </g>`,
  },

  ARROW_LEFT: {
    svgViewBox: '0 0 7 9',
    svgPath: `<path d="M6 1L2 4.77l3.78 3.564" stroke="currentColor" stroke-width="2" fill="none"/>`,
  },

  ARROW2: {
    svgViewBox: '0 0 13 12',
    svgPath:
      '<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2" transform="translate(2 1)"><line x1="11" y1="5" y2="5"/><polyline points="5 0 0 5 5 10"/></g>',
  },

  BAG: {
    svgViewBox: '0 0 16 18',
    svgPath:
      '<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(1 1)"><path d="M9.57894737,4.83552632 L9.57894737,2.625 C9.57894737,1.40390526 8.42461053,0.414473684 7,0.414473684 L7,0.414473684 C5.57538947,0.414473684 4.42105263,1.40390526 4.42105263,2.625 L4.42105263,4.83552632"/><polygon points="13.678 15.474 .507 15.474 1.52 5.158 12.664 5.158"/></g>',
  },

  BIN: {
    svgViewBox: '0 0 24 26',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1.5" transform="translate(1 1)"><path stroke-linecap="square" d="M19.7419355,7.35483871 L19.7419355,21.2903226 C19.7419355,22.5730485 18.7020807,23.6129032 17.4193548,23.6129032 L5.03225806,23.6129032 C3.74953219,23.6129032 2.70967742,22.5730485 2.70967742,21.2903226 L2.70967742,7.35483871"/><line x1="11.226" x2="11.226" y1="11.226" y2="18.968" stroke-linecap="square"/><line x1="7.355" x2="7.355" y1="11.226" y2="18.968" stroke-linecap="square"/><line x1="15.097" x2="15.097" y1="11.226" y2="18.968" stroke-linecap="square"/><polyline points="7.355 4.258 7.355 .387 15.097 .387 15.097 4.258"/><line x1="22.065" x2=".387" y1="4.258" y2="4.258" stroke-linecap="square"/></g>`,
  },

  BOOK: {
    svgViewBox: '0 0 14 16',
    svgPath:
      '<path fill="currentColor" d="M12,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,14 C0,15.1045695 0.8954305,16 2,16 L12,16 C13.1045695,16 14,15.1045695 14,14 L14,2 C14,0.8954305 13.1045695,0 12,0 Z M8,11 L3,11 L3,10 L8,10 L8,11 Z M11,8 L3,8 L3,7 L11,7 L11,8 Z M11,5 L3,5 L3,4 L11,4 L11,5 Z"/>',
  },

  CAMERA: {
    svgViewBox: '0 0 16 14',
    svgPath: `<path d="M15 3h-2.5L10.8.4c-.2-.2-.5-.4-.8-.4H6c-.3 0-.6.2-.8.4L3.5 3H1a.94.94 0 0 0-1 1v9a.94.94 0 0 0 1 1h14a.94.94 0 0 0 1-1V4a.94.94 0 0 0-1-1zm-7 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" fill="currentColor" fill-rule="nonzero"/>`,
  },

  CLOSE: {
    svgViewBox: '0 0 18 18',
    svgPath: `<g transform="matrix(.707107 .707107 -.707107 .707107 9 .514719)" stroke="currentColor" fill="none" stroke-linejoin="round" stroke-width="1.5"><path d="M6 .667v10.667"/><path d="M.667 6h10.667"/></g>`,
  },

  CLONE: {
    svgViewBox: '0 0 1792 1792',
    svgPath: `<path d="M1664 1632v-1088q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5zm128-1088v1088q0 66-47 113t-113 47h-1088q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113zm-384-384v160h-128v-160q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h160v128h-160q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113z"/>`,
  },

  CROP: {
    svgViewBox: '0 0 25 25',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" transform="translate(1 1)">
    <line x1="5.5" x2="5.5" y1=".5" y2="6.5"/>
    <line x1="17.5" x2="17.5" y1="20.5" y2="22.5"/>
    <polyline points=".5 6.5 17.5 6.5 17.5 16.5"/>
    <polyline points="5.5 10.5 5.5 16.5 22.5 16.5"/>
  </g>`,
  },

  DROPBOX: {
    svgViewBox: '0 0 16 16',
    svgPath: `<g fill="currentColor">
    <polygon points="4.7 .3 0 3.4 3.3 6 8 3"/>
    <polygon points="0 8.6 4.7 11.6 8 8.9 3.3 6"/>
    <polygon points="8 8.9 11.3 11.6 16 8.6 12.7 6"/>
    <polygon points="16 3.4 11.3 .3 8 3 12.7 6"/>
    <polygon points="11.2 12.9 8 10.2 4.8 12.9 3.3 11.9 3.3 12.9 8 15.7 12.7 12.9 12.7 11.9"/>
  </g>`,
  },

  DROPDOWN: {
    svgViewBox: '0 0 255 255',
    svgPath: `<g fill="#000">
    <polygon points="0,63.75 127.5,191.25 255,63.75" />
  </g>`,
  },

  EDIT: {
    svgViewBox: '0 0 24 24',
    svgPath: `<g fill="currentColor">
    <path d="M 18 0 L 2.8125 15.1875 L 0 24 L 8.8125 21.1875 L 24 6 C 24 6 23.898438 3.898438 22 2 C 20.101563 0.101563 18 0 18 0 Z M 3.90625 16.1875 C 3.90625 16.1875 5.113281 16.488281 6.3125 17.6875 C 7.613281 18.886719 7.8125 20 7.8125 20 L 7.84375 20.0625 L 4.28125 21.1875 L 2.78125 19.6875 Z" />
  </g>`,
  },

  FACEBOOK: {
    svgViewBox: '0 0 16 16',
    svgPath: `<path d="M16 8.048A8 8 0 0 0 .044 7.21a8 8 0 0 0 6.706 8.738V10.36H4.72V8.048h2.03V6.285a2.82 2.82 0 0 1 3.021-3.112 12.2 12.2 0 0 1 1.791.156V5.3h-1.008c-.348-.045-.697.07-.95.313s-.382.588-.35.937v1.5h2.22l-.355 2.312H9.25v5.59A8 8 0 0 0 16 8.048z" fill="currentColor" fill-rule="nonzero"/>`,
  },

  FOLDER: {
    svgViewBox: '0 0 16 16',
    svgPath: `<path fill="currentColor" d="M15 7L1 7C.4 7 0 7.4 0 8L0 15C0 15.6.4 16 1 16L15 16C15.6 16 16 15.6 16 15L16 8C16 7.4 15.6 7 15 7zM14 2L7.4 2 5.7.3C5.5.1 5.3 0 5 0L2 0C1.4 0 1 .4 1 1L1 5 15 5 15 3C15 2.4 14.6 2 14 2z"/>
    `,
  },

  GOOGLE_DRIVE: {
    svgViewBox: '0 0 16 16',
    svgPath: `<g fill="currentColor">
    <polygon points="10.667 0 5.333 0 10.133 9 15.467 9"/>
    <polygon points="4.747 1.026 0 9.333 2.667 14 7.322 5.854"/>
    <polygon points="6.104 10 3.818 14 13.5 14 16 10"/>
  </g>`,
  },

  FRAME: {
    svgViewBox: '0 0 23 23',
    svgPath: `<g fill="none" fill-rule="evenodd" transform="translate(1 1)">
    <rect width="20" height="20" x=".5" y=".5" stroke="currentColor" stroke-linecap="square" stroke-width="1.5"/><polygon fill="currentColor" fill-rule="nonzero" points="3.5 15.5 6.5 10.5 9.5 13.5 13.5 7.5 17.5 15.5"/><circle cx="8" cy="6" r="1.5" fill="currentColor" fill-rule="nonzero"/></g>`,
  },

  HEART: {
    svgViewBox: '0 0 11 10',
    svgPath: `<path fill="none" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" d="M43.118589,4.88141127 C42.2013094,3.96413173 40.7138524,3.96413173 39.7965728,4.88141127 C39.683456,4.99452806 39.5852684,5.1165449 39.5000001,5.24459081 C39.4147319,5.1165449 39.3165442,4.99452806 39.2034274,4.88169837 C38.2861479,3.96441883 36.7986908,3.96441883 35.8814113,4.88169837 C34.9641317,5.79897791 34.9641317,7.28643497 35.8814113,8.20371451 L39.5000001,11.8220163 L43.118589,8.20342742 C44.0358685,7.28614787 44.0358685,5.79897791 43.118589,4.88141127 Z" transform="translate(-34 -3)"/>`,
  },

  INFO: {
    svgViewBox: '0 0 16 16',
    svgPath: `<path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6a.94.94 0 0 1-1-1 .94.94 0 0 1 1-1 .94.94 0 0 1 1 1 .94.94 0 0 1-1 1z" fill="currentColor" fill-rule="evenodd"/>`,
  },

  INFO_TINY: {
    svgViewBox: '0 0 111.577 111.577',
    svgPath: `<path fill="currentColor" d="M78.962,99.536l-1.559,6.373c-4.677,1.846-8.413,3.251-11.195,4.217c-2.785,0.969-6.021,1.451-9.708,1.451 c-5.662,0-10.066-1.387-13.207-4.142c-3.141-2.766-4.712-6.271-4.712-10.523c0-1.646,0.114-3.339,0.351-5.064 c0.239-1.727,0.619-3.672,1.139-5.846l5.845-20.688c0.52-1.981,0.962-3.858,1.316-5.633c0.359-1.764,0.532-3.387,0.532-4.848 c0-2.642-0.547-4.49-1.636-5.529c-1.089-1.036-3.167-1.562-6.252-1.562c-1.511,0-3.064,0.242-4.647,0.71 c-1.59,0.47-2.949,0.924-4.09,1.346l1.563-6.378c3.829-1.559,7.489-2.894,10.99-4.002c3.501-1.111,6.809-1.667,9.938-1.667 c5.623,0,9.962,1.359,13.009,4.077c3.047,2.72,4.57,6.246,4.57,10.591c0,0.899-0.1,2.483-0.315,4.747 c-0.21,2.269-0.601,4.348-1.171,6.239l-5.82,20.605c-0.477,1.655-0.906,3.547-1.279,5.676c-0.385,2.115-0.569,3.731-0.569,4.815 c0,2.736,0.61,4.604,1.833,5.597c1.232,0.993,3.354,1.487,6.368,1.487c1.415,0,3.025-0.251,4.814-0.744 C76.854,100.348,78.155,99.915,78.962,99.536z M80.438,13.03c0,3.59-1.353,6.656-4.072,9.177c-2.712,2.53-5.98,3.796-9.803,3.796 c-3.835,0-7.111-1.266-9.854-3.796c-2.738-2.522-4.11-5.587-4.11-9.177c0-3.583,1.372-6.654,4.11-9.207 C59.447,1.274,62.729,0,66.563,0c3.822,0,7.091,1.277,9.803,3.823C79.087,6.376,80.438,9.448,80.438,13.03z"/>`,
  },

  INSTAGRAM: {
    svgViewBox: '0 0 16 16',
    svgPath: `<g fill="currentColor">
    <circle cx="12.145" cy="3.892" r="1"/>
    <path d="M8,12 C5.794,12 4,10.206 4,8 C4,5.794 5.794,4 8,4 C10.206,4 12,5.794 12,8 C12,10.206 10.206,12 8,12 Z M8,6 C6.897,6 6,6.897 6,8 C6,9.103 6.897,10 8,10 C9.103,10 10,9.103 10,8 C10,6.897 9.103,6 8,6 Z"/>
    <path d="M12,16 L4,16 C1.944,16 0,14.056 0,12 L0,4 C0,1.944 1.944,0 4,0 L12,0 C14.056,0 16,1.944 16,4 L16,12 C16,14.056 14.056,16 12,16 Z M4,2 C3.065,2 2,3.065 2,4 L2,12 C2,12.953 3.047,14 4,14 L12,14 C12.935,14 14,12.935 14,12 L14,4 C14,3.065 12.935,2 12,2 L4,2 Z"/></g>`,
  },

  LAYOUT: {
    svgViewBox: '0 0 23 26',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" transform="translate(1 1)"><rect width="8.516" height="13.161" x=".387" y=".387"/><rect width="8.516" height="6.968" x=".387" y="16.645"/><rect width="8.516" height="6.968" x="12" y=".387"/><rect width="8.516" height="13.161" x="12" y="10.452"/></g>`,
  },

  LINK: {
    svgViewBox: '0 0 18 16',
    svgPath: `<g fill="currentColor">
    <path d="M5.5,16 C4.3,16 3.2,15.5 2.3,14.7 C0.5,12.9 0.5,10.1 2.3,8.3 L3,7.6 L4.4,9 L3.7,9.7 C2.7,10.7 2.7,12.3 3.7,13.3 C4.7,14.3 6.3,14.3 7.3,13.3 L10.3,10.3 C11.3,9.3 11.3,7.7 10.3,6.7 L9.6,6 L11,4.6 L11.7,5.3 C13.5,7.1 13.5,9.9 11.7,11.7 L8.7,14.7 C7.9,15.5 6.7,16 5.5,16 Z"/>
    <path d="M7,11.4 L6.3,10.7 C4.5,8.9 4.5,6.1 6.3,4.3 L9.3,1.3 C10.2,0.4 11.3,8.8817842e-16 12.5,8.8817842e-16 C13.7,8.8817842e-16 14.8,0.5 15.7,1.3 C17.5,3.1 17.5,5.9 15.7,7.7 L15,8.4 L13.6,7 L14.3,6.3 C15.3,5.3 15.3,3.7 14.3,2.7 C13.3,1.7 11.7,1.7 10.7,2.7 L7.7,5.7 C6.7,6.7 6.7,8.3 7.7,9.3 L8.4,10 L7,11.4 Z"/></g>`,
  },

  MOVE: {
    svgViewBox: '0 0 26 18',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" transform="translate(1 2)"><polygon points=".414 7.034 7.862 .414 7.862 13.655"/><polygon points="23.31 7.034 15.862 .414 15.862 13.655"/></g>`,
  },

  ONEDRIVE: {
    svgViewBox: '0 0 21 14',
    svgPath: `<g fill="curentCOLOR">
    <path d="M11.1040844,0.0200109649 C10.8132451,0.0200109649 10.5261678,0.0462253289 10.245614,0.0970932018 C9.26063432,0.275631031 8.35661897,0.759216009 7.65655537,1.48961623 C7.39701316,1.43854825 7.13302851,1.41277412 6.86776316,1.41277412 C4.80447259,1.41277412 3.09381524,2.95133717 2.8229068,4.94146765 C1.22299013,5.210375 0,6.60533936 0,8.28053728 C0,10.0854863 1.41973794,11.5648569 3.20107401,11.6611497 C3.12327138,11.3419348 3.0816886,11.0086721 3.0816886,10.6658443 C3.0816886,9.70439748 3.41595175,8.76388213 4.0228443,8.01755318 C4.42166283,7.52708443 4.9265795,7.13378893 5.49180921,6.86592215 C5.85020559,4.45548136 7.80667763,2.55980263 10.245614,2.29357675 C10.4395603,2.27240515 10.6364682,2.26123904 10.8359375,2.26123904 C12.094267,2.26123904 13.2828783,2.6860318 14.2415636,3.46826042 C14.3236886,3.46405811 14.4058536,3.46189693 14.4879386,3.46189693 C14.9129715,3.46189693 15.3328416,3.518608 15.7373832,3.62786787 C15.2138964,1.5570932 13.335227,0.0200109649 11.1040844,0.0200109649 Z"/>
    <path d="M18.0482495,7.71630811 C17.7834644,5.98940186 16.2877648,4.66255482 14.4879386,4.66255482 C14.2689786,4.66255482 14.0510192,4.68244572 13.8363416,4.72190735 C13.0481096,3.91682621 11.9744814,3.46189693 10.8359375,3.46189693 C10.6355877,3.46189693 10.4385598,3.47630482 10.245614,3.50355976 C8.20697697,3.7914375 6.63363487,5.54739967 6.63363487,7.66419956 C6.63363487,7.68777248 6.63383498,7.71138542 6.6342352,7.73503838 C5.29041886,8.03272149 4.28234649,9.23377961 4.28234649,10.6658443 C4.28234649,12.3209512 5.62888432,13.667489 7.28399123,13.667489 L17.4895833,13.667489 C19.1446902,13.667489 20.4912281,12.3209512 20.4912281,10.6658443 C20.4912281,9.20156195 19.4374106,7.97881195 18.0482495,7.71630811 Z"/></g>`,
  },

  PALETTE: {
    svgViewBox: '0 0 26 25',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" transform="translate(1 1)">
    <path d="M0.387096774,10.4516129 C0.387096774,6.50322581 2.32258065,3.01935484 5.34193548,0.929032258 C6.42580645,0.15483871 8.12903226,1.66533454e-16 8.90322581,0.929032258 C9.90967742,2.24516129 8.12903226,4.10322581 8.90322581,5.18709677 C10.9935484,7.74193548 15.4064516,2.70967742 20.5935484,5.18709677 C24.3096774,7.04516129 23.7677419,11.9225806 23.3032258,13.7032258 C21.9096774,18.5806452 17.4193548,22.2193548 12.0774194,22.2193548 C5.6516129,22.1419355 0.387096774,16.9548387 0.387096774,10.4516129 Z"/>
    <circle cx="17.419" cy="9.677" r="2.323"/>
    <circle cx="5.032" cy="9.677" r="1.548"/>
    <circle cx="6.581" cy="15.097" r="1.548"/>
    <circle cx="12" cy="17.419" r="1.548"/></g>`,
  },

  QUESTION: {
    svgViewBox: '0 0 16 16',
    svgPath: `<g fill="none" fill-rule="evenodd">
    <circle cx="8" cy="8" r="7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="8.003" cy="12" r="1" fill="currentColor" fill-rule="nonzero"/>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6.5,3.577 C7.453,2.717 9.518,2.732 9.923,4.212 C10.453,6.134 8,6.142 8,9"/></g>`,
  },

  SAVE: {
    svgViewBox: '0 0 438.533 438.533',
    svgPath: `<path d="M432.823,121.049c-3.806-9.132-8.377-16.367-13.709-21.695l-79.941-79.942c-5.325-5.325-12.56-9.895-21.696-13.704
		C308.346,1.903,299.969,0,292.357,0H27.409C19.798,0,13.325,2.663,7.995,7.993c-5.33,5.327-7.992,11.799-7.992,19.414v383.719
		c0,7.617,2.662,14.089,7.992,19.417c5.33,5.325,11.803,7.991,19.414,7.991h383.718c7.618,0,14.089-2.666,19.417-7.991
		c5.325-5.328,7.987-11.8,7.987-19.417V146.178C438.531,138.562,436.629,130.188,432.823,121.049z M182.725,45.677
		c0-2.474,0.905-4.611,2.714-6.423c1.807-1.804,3.949-2.708,6.423-2.708h54.819c2.468,0,4.609,0.902,6.417,2.708
		c1.813,1.812,2.717,3.949,2.717,6.423v91.362c0,2.478-0.91,4.618-2.717,6.427c-1.808,1.803-3.949,2.708-6.417,2.708h-54.819
		c-2.474,0-4.617-0.902-6.423-2.708c-1.809-1.812-2.714-3.949-2.714-6.427V45.677z M328.906,401.991H109.633V292.355h219.273
		V401.991z M402,401.991h-36.552h-0.007V283.218c0-7.617-2.663-14.085-7.991-19.417c-5.328-5.328-11.8-7.994-19.41-7.994H100.498
		c-7.614,0-14.087,2.666-19.417,7.994c-5.327,5.328-7.992,11.8-7.992,19.417v118.773H36.544V36.542h36.544v118.771
		c0,7.615,2.662,14.084,7.992,19.414c5.33,5.327,11.803,7.993,19.417,7.993h164.456c7.61,0,14.089-2.666,19.41-7.993
		c5.325-5.327,7.994-11.799,7.994-19.414V36.542c2.854,0,6.563,0.95,11.136,2.853c4.572,1.902,7.806,3.805,9.709,5.708l80.232,80.23
		c1.902,1.903,3.806,5.19,5.708,9.851c1.909,4.665,2.857,8.33,2.857,10.994V401.991z"/>`,
  },

  PAGE: {
    svgViewBox: '0 0 49.356 49.356',
    svgPath: `<path stroke="currentColor" d="M7.97,49.356h33.417c1.103,0,2-0.897,2-2V11.701c0-0.843-0.46-1.857-1.093-2.411l-9.559-8.383
    C32.135,0.382,31.121,0,30.324,0H7.97c-1.103,0-2,0.897-2,2v45.355C5.97,48.459,6.866,49.356,7.97,49.356z M32.304,4.519
    l5.881,5.159h-5.882L32.304,4.519z M8.97,3h20.333v7.678c0,1.103,0.897,2,2,2h9.084v33.678H8.97V3L8.97,3z"/>`,
  },

  REFRESH: {
    svgViewBox: '0 0 383.748 383.748',
    svgPath: `<g>
    <path d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30 C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593 L2.081,34.641v113.365h113.91L62.772,95.042z"/>
    <path d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042 c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888 c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z"/>
    </g>`,
  },

  REMOVE: {
    svgViewBox: '0 0 8 2',
    svgPath: `<path d="M.444 1h7.11" stroke="currentColor" stroke-width="2" fill="none"/>`,
  },

  REPLACE: {
    svgViewBox: '0 0 25 25',
    svgPath: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="1.5" transform="translate(1 1)">
    <polyline points="6.5 12.5 .5 12.5 .5 .5 12.5 .5 12.5 6.5"/>
    <rect width="12" height="12" x="10.5" y="10.5"/>
    <path d="M16.5 1.5C19.261 1.5 21.5 3.739 21.5 6.5M6.5 21.5C3.739 21.5 1.5 19.261 1.5 16.5"/></g>`,
  },

  ROTATE_LEFT: {
    svgViewBox: '0 0 24 24',
    svgPath: `<path d="M 4 2 L 4 7 L 9 7 L 7.4375 5.4375 C 8.7316965 4.5353856 10.297977 4 12 4 C 16.430666 4 20 7.5693339 20 12 C 20 16.430666 16.430666 20 12 20 C 11.405 20 10.812328 19.908344 10.236328 19.777344 L 9.7988281 21.753906 C 10.516828 21.917906 11.257 22 12 22 C 17.511334 22 22 17.511334 22 12 C 22 6.4886661 17.511334 2 12 2 C 9.7532162 2 7.6716357 2.7446772 6 4 L 4 2 z M 2.0019531 12 C 2.0139531 12.753 2.1062969 13.536766 2.2792969 14.259766 L 4.2246094 13.783203 C 4.0866094 13.204203 4.01 12.605 4 12 L 2.0019531 12 z M 4.8300781 15.470703 L 3.0390625 16.371094 C 3.3670625 17.041094 3.7712812 17.677766 4.2382812 18.259766 L 5.7890625 16.980469 C 5.4150625 16.514469 5.0930781 16.007703 4.8300781 15.470703 z M 7.0546875 18.242188 L 5.8183594 19.832031 C 6.4013594 20.297031 7.0341719 20.697531 7.7011719 21.019531 L 8.5605469 19.189453 C 8.0285469 18.932453 7.5216875 18.614187 7.0546875 18.242188 z"/>`,
  },

  ROTATE_RIGHT: {
    svgViewBox: '0 0 24 24',
    svgPath: `<path d="M 12.001953 2 C 6.4906193 2 2.0019531 6.4886661 2.0019531 12 C 2.0019531 17.511334 6.4906193 22 12.001953 22 C 12.744953 22 13.485125 21.917906 14.203125 21.753906 L 13.765625 19.777344 C 13.189625 19.908344 12.596953 20 12.001953 20 C 7.5712872 20 4.0019531 16.430666 4.0019531 12 C 4.0019531 7.5693339 7.5712872 4 12.001953 4 C 13.704556 4 15.270464 4.5348237 16.564453 5.4375 L 15.001953 7 L 20.001953 7 L 20.001953 2 L 18.001953 4 C 16.330317 2.7446772 14.248737 2 12.001953 2 z M 20.001953 12 C 19.991953 12.605 19.915344 13.204203 19.777344 13.783203 L 21.720703 14.259766 C 21.893703 13.536766 21.988 12.753 22 12 L 20.001953 12 z M 19.171875 15.470703 C 18.908875 16.006703 18.584937 16.514469 18.210938 16.980469 L 19.763672 18.259766 C 20.230672 17.677766 20.634891 17.041094 20.962891 16.371094 L 19.171875 15.470703 z M 16.945312 18.242188 C 16.479312 18.614188 15.972453 18.932453 15.439453 19.189453 L 16.300781 21.019531 C 16.966781 20.697531 17.600594 20.297031 18.183594 19.832031 L 16.945312 18.242188 z"/>`,
  },

  USER: {
    svgViewBox: '0 0 30 30',
    svgPath: `<path d="M18,19v-2c0.45-0.223,1.737-1.755,1.872-2.952c0.354-0.027,0.91-0.352,1.074-1.635c0.088-0.689-0.262-1.076-0.474-1.198 c0,0,0.528-1.003,0.528-2.214c0-2.428-0.953-4.5-3-4.5c0,0-0.711-1.5-3-1.5c-4.242,0-6,2.721-6,6c0,1.104,0.528,2.214,0.528,2.214 c-0.212,0.122-0.562,0.51-0.474,1.198c0.164,1.283,0.72,1.608,1.074,1.635C10.263,15.245,11.55,16.777,12,17v2c-1,3-9,1-9,8h24 C27,20,19,22,18,19z"/>`,
  },

  MAGIC: {
    svgViewBox: '2 2 20 20',
    svgPath: `<path d="M19.707,4.293a1,1,0,0,1,0,1.414L18.152,7.262a1,1,0,0,1-1.414-1.414l1.555-1.555A1,1,0,0,1,19.707,4.293ZM21,10H18.8a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2ZM14,5.2V3a1,1,0,0,0-2,0V5.2a1,1,0,0,0,2,0Zm1.689,4.916-1.8-1.8a1.064,1.064,0,0,0-1.5,0l-1.8,1.8,3.307,3.307,1.8-1.8A1.064,1.064,0,0,0,15.689,10.114ZM2.312,19.886l1.8,1.8a1.062,1.062,0,0,0,1.5,0l6.764-6.763L9.075,11.618,2.312,18.382A1.062,1.062,0,0,0,2.312,19.886Z" />`,
  },

  LEAF: {
    svgViewBox: '0 0 256 256',
    svgPath: `<path d="M209.28,8.32c66.2416,158.42016 -9.73056,227.072 -55.5136,227.072c-18.9412,0 -31.91936,-5.9136 -40.19584,-14.08c-5.47984,-5.4272 -8.49664,-11.45856 -10.39936,-17.28c-11.2,9.7792 -22.72,17.96032 -34.176,23.8336c-16.52352,8.44288 -33.2288,12.16 -48.64,7.8336c-2.73792,-0.75968 -4.35968,-3.58208 -3.59808,-6.31936c0.75968,-2.73792 3.58208,-4.35968 6.31936,-3.59808c12.02048,3.3536 26.17984,0.67968 41.28,-7.04c9.85984,-5.03808 19.96736,-12.23808 30.08,-20.8c-4.51584,-1.03936 -9.19936,-2.77888 -14.24,-5.44c-9.55584,-5.05856 -19.46048,-12.6336 -27.52,-22.4c-16.0896,-19.52 -24.03584,-48.71936 -3.52,-80.32c22.93696,-35.44768 55.76128,-47.18016 84.99264,-54.5536c14.58752,-3.69664 28.36032,-6.3808 39.8336,-10.39936c11.47968,-4.01856 20.43712,-9.18976 26.3936,-17.6c0.7984,-1.2192 2.08,-2.0192 3.52,-2.24c2.3424,-0.32 4.57728,0.99904 5.44,3.2z M202.752,19.2c59.1616,149.04256 -13.82912,205.9136 -48.2816,205.9136c-16.896,0 -26.72,-4.86144 -32.96,-11.0336c-5.3504,-5.29664 -8.03584,-11.87776 -9.44,-17.728c2.08,-1.97696 4.2,-3.85536 6.24,-5.9136c31.25824,-31.57504 58.6752,-73.35296 72.576,-108.1536c0.6992,-1.69984 0.44032,-3.63392 -0.67968,-5.09504c-1.1201,-1.45856 -2.94016,-2.19648 -4.75968,-1.93536c-1.83936,0.29952 -3.38048,1.6 -3.99936,3.35936c-13.21984,33.17632 -40.19584,74.2976 -70.4,104.71936c-2.0992,2.11968 -4.28032,4.05888 -6.4,6.08c-3.99936,0.06016 -11.30048,-1.65888 -19.04,-5.76c-8.4224,-4.43776 -17.40992,-11.29856 -24.48,-19.84c-14.10048,-17.09504 -21.12,-39.9616 -2.72,-68.2816c21.09952,-32.64 50.2016,-43.0336 78.72,-50.304c14.2592,-3.60448 28.30016,-6.3424 40.83776,-10.71936c9.5424,-3.34848 17.79968,-8.52992 24.784,-15.1936z" fill="#94d82d"/>`,
  }
};

const Icon = forwardRef((props, ref) => {
  const icon = props.type;
  return (
    <IconStyles
      {...props}
      fill="currentColor"
      ref={ref}
      viewBox={icon.svgViewBox}
      width={`${props.width}px`}
      height={`${props.height}px`}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      dangerouslySetInnerHTML={{ __html: icon.svgPath }}
    />
  );
});

Icon.propTypes = {
  type: PropTypes.object.isRequired,
  rotate: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

Icon.defaultProps = {
  rotate: undefined,
  width: 18,
  height: 18,
};

export default Icon;
